var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integration_content"},[_c('IntegrationForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }